/* XELAE — chargeur + surcouche galerie de la fiche Coolmax Sport (asset : xelae-produit.js).
   Galerie sur-mesure : 1re vignette = coloris sélectionné (géré par le bundle via
   galleryImages()), puis les 5 images de la fiche. Le bundle produit (xelae-produit-app-v2)
   est désormais piloté par le nombre RÉEL d'images => flèches gauche/droite + swipe tactile
   sur exactement 6 vignettes, comme la fiche Performance. Plus aucun masquage de flèches/vignettes.
   Garde-fou d'URL : n'affecte pas les autres fiches. */
(function () {
  if (location.pathname.indexOf('xelae-sport') !== -1 && window.XELAE) {
    var CI = window.XELAE.colorImg || {};
    var c0 = CI['Gris/Marine'] || CI['Noir'] || (window.XELAE.gallery && window.XELAE.gallery[0]) || '';
    var imgs = [
      'https://cdn.shopify.com/s/files/1/0799/9825/5127/files/f8823af3-8d87-4745-be98-606ee8d38ec5.png?v=1783357359',
      'https://cdn.shopify.com/s/files/1/0799/9825/5127/files/4fc19ca5-e3eb-4775-ad3d-cd575c30be8c.png?v=1783357358',
      'https://cdn.shopify.com/s/files/1/0799/9825/5127/files/f5a5786c-29bc-4f9c-8bd3-82164ef5e801.png?v=1783357358',
      'https://cdn.shopify.com/s/files/1/0799/9825/5127/files/27982d5f-432b-4671-926d-9f1dc9a18af5.png?v=1783357359',
      'https://cdn.shopify.com/s/files/1/0799/9825/5127/files/f2f8802f-2fc7-47b7-86d9-97ed0a9f367d.png?v=1783357358'
    ];
    window.XELAE.gallery = [c0].concat(imgs);
  }
  var s = document.createElement('script');
  s.src = 'https://cdn.shopify.com/s/files/1/0799/9825/5127/files/xelae-produit-app-v2.js?v=1783362268';
  s.defer = true;
  (document.head || document.documentElement).appendChild(s);
})();
